/**
 * Loads a callback after DOM is loaded. Works for async functions or promises that
 * may finish loading after document triggers DOMContentLoaded event.
 *
 * @param callback function to run.
 */
const DOMReady = (callback) => {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback);
  } else if (document.attachEvent) {
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState !== 'loading') {
        callback();
      }
    });
  }
};

export default DOMReady;